"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
var doesCountryHaveRegions = function (country) {
    var countryData = (0, index_1.getRegionsByCountry)(country);
    return countryData && countryData.regions.length > 0;
};
exports.default = doesCountryHaveRegions;
